import axios from "axios";
import {
  getRedirectsURL,
  createRedirectURL,
  updateRedirectURL,
  deleteRedirectURL,
  getRedirectByIdURL,
} from "config/config";
import { dkeysApi } from "./api";

const handleRedirectError = (error, operation = "operation") => {
  console.error(`Error ${operation}:`, error);
  throw error;
};

export const redirectsAPI = {
  async getRedirects() {
    try {
      const response = await axios.get(getRedirectsURL);
      if (!response.data.success && response.data.error) {
        throw new Error(response.data.message || "Ошибка при получении редиректов");
      }
      return response.data;
    } catch (error) {
      handleRedirectError(error, "fetching redirects");
    }
  },

  async createRedirect(data) {
    try {
      return await dkeysApi.postFormData(data, createRedirectURL);
    } catch (error) {
      handleRedirectError(error, "creating redirect");
    }
  },

  async updateRedirect(data) {
    try {
      return await dkeysApi.postFormData(data, updateRedirectURL);
    } catch (error) {
      handleRedirectError(error, "updating redirect");
    }
  },

  async deleteRedirect(id) {
    try {
      const response = await axios.post(
        deleteRedirectURL,
        { id },
        { headers: { "Content-Type": "application/json" } }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || "Ошибка при удалении редиректа");
      }
      return response.data;
    } catch (error) {
      handleRedirectError(error, "deleting redirect");
    }
  },

  async getRedirectById(id) {
    try {
      const url = `${getRedirectByIdURL}/${encodeURIComponent(id)}`;
      const response = await axios.get(url);

      if (!response.data.success) {
        throw new Error(response.data.message || "Ошибка при получении редиректа");
      }
      return response.data;
    } catch (error) {
      handleRedirectError(error, "fetching redirect by ID");
    }
  },
};

